export const chat = {
  welcomeMessage: "Ciao! Sono l'assistente di Victor. Posso aiutarti con servizi, competenze, progetti o contatti. In cosa posso esserti utile?",
  messagePlaceholder: "Scrivi un messaggio...",
  thinking: "Sto pensando...",
  openChat: "Chatta con il mio gemello AI",
  typingStatus: "AI sta pensando...",
  tabs: {
    info: "Victor AI",
    email: "Modulo di contatto"
  },
  modes: {
    info: {
      welcome: {
        title: "Benvenuto al mio Assistente AI",
        description: "Sentiti libero di chiedermi qualsiasi cosa sulle competenze, i servizi o il portfolio di Victor."
      }
    },
    email: {
      title: "Inviami un messaggio",
      description: "Compila il modulo sottostante per metterti in contatto direttamente con Victor.",
      form: {
        name: "Il tuo nome",
        email: "La tua email",
        message: "Il tuo messaggio",
        send: "Invia",
        sending: "Invio in corso...",
        success: "Messaggio inviato con successo!",
        error: "Impossibile inviare il messaggio. Riprova per favore."
      }
    }
  }
}; 